export default __webpack_public_path__ + "static/media/11.b4100642.png";